module.exports = __webpack_public_path__ + "img/pre_loading_d4cb64a62.png";